// extracted by mini-css-extract-plugin
module.exports = {"code":"index_code_2KGDu","wrapperMode":"index_wrapperMode_3auH-"};